import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';


import { AppComponent } from './app.component';
import { ImageService } from './typewriter/output/ImageController';
import { FeedService } from './typewriter/output/FeedController';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HomeComponent } from './home/home.component';
import { EventService } from './typewriter/output/EventController';
import { ProductService } from './typewriter/output/ProductController';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { LinksComponent } from './links/links.component';
import { FaqComponent } from './faq/faq.component';
import { LinkService } from './typewriter/output/LinkController';
import { FaqService } from './typewriter/output/FaqController';
import { MessageService } from './typewriter/output/MessageController';
import { PropertyNormalizerPipe } from './pipes/property-normalizer.pipe';
import { SharedModule } from './shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
//import { SlickModule } from 'ngx-slick';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    HomeComponent,
    AboutComponent,
    ContactComponent,
    LinksComponent,
    FaqComponent,
    PropertyNormalizerPipe
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    RouterModule.forRoot([
      { path: '', pathMatch: 'full', redirectTo: 'home' },
      { path: 'about', component: AboutComponent },
      { path: 'contact', component: ContactComponent },
      { path: 'event', loadChildren: 'app/events/events.module#EventsModule' },
      { path: 'faq', component: FaqComponent },
      { path: 'home', component: HomeComponent },
      { path: 'links', component: LinksComponent },
      { path: 'products', loadChildren: 'app/products/products.module#ProductsModule' },
      // Shortcuts
      { path: 'maps', redirectTo: 'products/maps' },
      { path: 'events', redirectTo: 'event' },
      { path: 'proofs', redirectTo: 'event' },
      // Legacy redirects
      { path: 'About.aspx', redirectTo: 'about' },
      { path: 'Contact.aspx', redirectTo: 'contact' },
      { path: 'Faq.aspx', redirectTo: 'faq' },
      { path: 'FindProofs.aspx', redirectTo: 'event' },
      { path: 'FindResults.aspx', redirectTo: 'event' },
      { path: 'Links.aspx', redirectTo: 'links' },
      { path: 'Maps.aspx', redirectTo: 'products/maps' },
      { path: 'OrderPage.aspx', redirectTo: 'event' },
      { path: 'SearchResults.aspx', redirectTo: 'event' },

      { path: '**', component: PageNotFoundComponent }
    ]),
    SharedModule,
    //SlickModule.forRoot(),
    NgbModule.forRoot()
  ],
  providers: [
    EventService,
    FaqService,
    FeedService,
    ImageService,
    LinkService,
    MessageService,
    ProductService,
    PropertyNormalizerPipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts